import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const HandsHeart = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="66" viewBox="0 0 64 66" width="64" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M32.82 64.94c12.69 0 22.97-1.52 22.97-3.4s-10.28-3.4-22.97-3.4-22.97 1.52-22.97 3.4 10.28 3.4 22.97 3.4Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.68 42.74c-1.85 3.1-4.73 4.8-6.94 6.48-1.91 1.44-5.42 2.83-9.13 3.71.46-1.64.56-3 .38-4.14a5.1 5.1 0 0 0-5.1-4.59c-2.36 0-4.31 1.88-4.62 4.4q-.11.77.02 1.59a7 7 0 0 0 1.95 3.68q-2.09 0-3.64-.48a4.9 4.9 0 0 1-3.33-3.55 7 7 0 0 1-.17-2.16c.05-1.23.33-2.16.33-2.16 0-.05.02-2.47 4.32-4.66h.03c.13-.06.81-.32 1.68-.75 3.97-1.53 8.9-.99 11.74-.47q1.38-8.34-4.15-13.79c-.95.8-2.26 1.77-3.85 2.55a14 14 0 0 1-4.89 1.42c-2.77.25-4.52-.36-5.43-1.47q-.55-.68-.69-1.6a5 5 0 0 1 .14-2.25q.13-.5.33-1v-.02a10 10 0 0 1 .83-1.68c.78 1.18 2.51 2.96 5.48 2.04 4.12-1.27 3.32-5.78-.27-7.43 2.48-1.67 5.43-2.75 8.39-2.36 2.9.38 7.05 3.16 10.44 5.99 2.29 1.9 4.45 3.9 5.94 6.57a15 15 0 0 1 1.81 5.42c.7 4.91-.12 8.25-1.6 10.71Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M45.6 52.94c-2.52.59-5.11.95-7.36.94a7 7 0 0 1-1.95-3.68 5 5 0 0 1-.02-1.59c.31-2.52 2.26-4.4 4.62-4.4a5.1 5.1 0 0 1 5.1 4.59 10 10 0 0 1-.38 4.14z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M35.77 40.86q.7-.36 1.55-.7l.13-.05" fill={shades.secondary.medium} />
      <path className={strokeStyle} d="M35.77 40.86q.7-.36 1.55-.7l.13-.05" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M49.18 39.64c1.4.26 2.28.52 2.28.52" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m35.94 32.24-3.58 1.68s-2.65-1.96-5.75-1.92a5 5 0 0 0 1.68-.62c.72.65 1.61 1.2 2.67 1.43 1.46.32 3.2.12 4.97-.57z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M49.18 39.64c-2.83-.52-7.77-1.06-11.74.47 2.32-1.16 6.06-3.56 5-6.59-1.23-3.53-4.95-2.01-5.39-1.81a14 14 0 0 0 4.11-3.3c1.6-.79 2.91-1.76 3.85-2.56q5.53 5.45 4.15 13.79z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M36.95 23.83c-2.97.92-4.7-.86-5.48-2.04a18 18 0 0 1 5.21-5.39c3.59 1.65 4.39 6.16.27 7.43Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M35.6 17.19a18 18 0 0 0-4.56 5.38q-.23.46-.4.91a7 7 0 0 0-.81-2.46l-.19-.34q.23-.95.62-2.03c.53-1.5 1.28-3.15 2.33-4.69l.28-.38a4.4 4.4 0 0 1 2.74 3.61z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.46 26.6c-1.49-2.67-3.65-4.67-5.94-6.57-3.4-2.83-7.55-5.61-10.44-5.99-2.96-.38-5.91.69-8.39 2.36q-.56.38-1.08.78a4.4 4.4 0 0 0-2.74-3.61c3.36-4.45 11.82-8.4 20.16-1.81 5.14 4.06 7.42 10.39 8.43 14.83z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M41.17 28.42a14 14 0 0 1-4.11 3.3l-.04.02-.11.06-.73.34-.24.11c-1.77.7-3.51.89-4.97.57a6 6 0 0 1-2.67-1.43 6.3 6.3 0 0 0 2.55-3.03c.91 1.11 2.66 1.72 5.43 1.47 1.81-.15 3.46-.71 4.89-1.41Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M46.75 24.19s-.61.73-1.71 1.66" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M31.9 49.83c-.56 3.42-3.89 4.7-7.08 4.16a9 9 0 0 0 1.38-4.25c.11-3.54-2.76-5.93-6.91-5.48-2.58.28-3.72 1.72-4.18 3.29a8 8 0 0 0-.2 3.2c-1.68-.56-3.71-1.28-6.27-2.26-4.99-1.89-7.47-6.36-8.1-11.16-.41-3.15-.03-6.44.98-9.23q.46-1.26 1.17-2.5c2.14-3.76 5.83-7.24 9.3-9.6a21 21 0 0 1 5.69-2.91c2.53-.7 5.67.94 8.23 3.17l.24.21-.31.11c-1.6.58-3.85 2.01-3.45 5.39.5 4.17 5.78 4.29 8.31 2.24.05 3.04-2.08 5.75-6.15 5.22a7.8 7.8 0 0 1-5.01-2.96 13 13 0 0 1-3.92 4.47 14 14 0 0 1-2.81 1.58c.33 1.95.99 3.8 1.89 5.55a28 28 0 0 1 4.02-.43q2.9-.12 5.29.57c3.49.99 6.09 3.33 7.42 7.31q.82 2.55.49 4.3z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M12.79 32.53c-.49.2-.78.29-.78.29" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M14.68 38.08q-1.08.2-2.2.47" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M17.73 23.29c-.09.27.38 2.01 1.8 3.19" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M30.69 24.22c-2.53 2.05-7.81 1.93-8.31-2.24-.39-3.39 1.86-4.81 3.45-5.39l.31-.11c1.6 1.44 2.94 3.1 3.69 4.54a7 7 0 0 1 .86 3.2Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M28.25 13.54a3.6 3.6 0 0 0-2.35 2.73c-2.55-2.23-5.7-3.86-8.23-3.17a20 20 0 0 0-5.69 2.91c-3.46 2.36-7.15 5.84-9.3 9.6.64-3.24 2-7.68 4.86-11.31a24 24 0 0 1 4.47-4.56c3.37-2.5 6.59-2.59 10.6-.53a18 18 0 0 1 5.63 4.32z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M29.83 21.02a18 18 0 0 0-3.69-4.54l-.24-.21a3.6 3.6 0 0 1 2.35-2.73c1.79 2.18 2.56 4.73 1.58 7.48Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M18.7 37.65a28 28 0 0 0-4.02.43 19 19 0 0 1-1.89-5.55c.67-.28 1.7-.77 2.81-1.58.41 2.53 1.97 5.12 3.1 6.7Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M23.99 38.22a16 16 0 0 0-5.29-.57c-1.13-1.58-2.69-4.16-3.1-6.7.94-.68 1.93-1.57 2.81-2.73a9 9 0 0 0 5.78 3.77q.67.13 1.27.12c-3.15.58-3.94 3.57-1.47 6.1z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M30.85 28.35a6.4 6.4 0 0 1-2.55 3.03q-.75.45-1.68.62-.53.11-1.14.11t-1.27-.12a9 9 0 0 1-5.78-3.77q.6-.79 1.11-1.74a7.8 7.8 0 0 0 5.01 2.96q1.17.16 2.13-.04a4.7 4.7 0 0 0 3.49-2.65q.13.91.69 1.6z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M26.2 49.74a9 9 0 0 1-1.38 4.25q-.9-.16-1.78-.51c-2.31-.94-4.36-1.46-8.12-2.73a8 8 0 0 1 .2-3.2c.46-1.57 1.6-3.01 4.18-3.29 4.14-.45 7.02 1.94 6.91 5.48z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M30.85 9.22c-1.36 0-3.52-2.93-4.05-4.83S26.49.86 28.18.44c1.7-.42 3.34 1.48 3.34 1.48S32.97.15 34.84.84c1.53.57 1.79 2.24 1.05 3.96-1.14 2.63-3.67 4.42-5.03 4.42z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M31.52 1.91s.92.88 1.1 1.48" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M57.38 21.66a42 42 0 0 0-3.67-3.07c1.74-4.71-.69-6.82-.69-6.82s3.03-1.37 4.91 1.58c1.35 2.1.2 6.18-.55 8.31Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
